import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'tmSupCurrency',
    standalone: false
})
export class SupCurrencyPipe implements PipeTransform {
    transform(value: string) {
        const [integral, decimal] = (value || 0.0).toString().split('.');
        return decimal == null ? value : `${integral}<sup>.${decimal}</sup>`;
    }
}
